module.exports = __webpack_public_path__ + "img/548-42dfb3.png";